import React from 'react';
import Icon from '@atlaskit/icon';
import image from './sprint.raw.svg';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function SprintIcon(props: any) {
	return <Icon label="" dangerouslySetGlyph={image} {...props} />;
}
